import * as stylex from '@stylexjs/stylex';
import '@tokens/colors.stylex';
import { colors } from '@tokens/colors.stylex';
import '@tokens/typography.stylex';
import { typography } from '@tokens/typography.stylex';
import '@tokens/spacing.stylex';
import { spacing } from '@tokens/spacing.stylex';
import '@tokens/radius.stylex';
import { radius } from '@tokens/radius.stylex';
import '@tokens/motion.stylex';
import { motion } from '@tokens/motion.stylex';

// Ported 1:1 from the prototype `.page-head` / `.page-title` / `.page-desc`.
export const styles = {
  head: {
    k1xSpc: "x78zum5",
    kGNEyG: "xuk3077",
    kjj79g: "x1qughib",
    kOIVth: "x1bof9c1",
    k1K539: "xrn58dq",
    kwnvtZ: "x1a02dak",
    $$css: true
  },
  titleWrap: {
    k1xSpc: "x78zum5",
    kGNEyG: "x1cy8zhl",
    kOIVth: "x1mnnc3i",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  backBtn: {
    kI3sdo: "x1a2a7pz xx4dj4q",
    kzqmXN: "x14qfxbe",
    kZKoxP: "xc9qbxq",
    kmuXW: "x2lah0s",
    k1xSpc: "xrvj5dj",
    kgQiWS: "x1ku5rj1",
    kaIpWk: "xxltkoq",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x1xo1f5v",
    kWkggS: "xjbqb8w",
    kMwMTN: "xdxw5r1",
    kkrTdU: "x1ypdohk",
    kmkexE: "x1k3q35m",
    kGzVvX: "x5lqt2c",
    kDPRdz: "x1tqbdv0",
    $$css: true
  },
  titleRow: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kOIVth: "x1mnnc3i",
    kwnvtZ: "x1a02dak",
    $$css: true
  },
  title: {
    kogj98: "x1ghz6dp",
    kMv6JI: "xpc6l4x",
    kGuDYH: "x1pvqxga",
    k63SB2: "xomqrzn",
    kLWn49: "x1u7k74",
    kMwMTN: "x1oezkus",
    $$css: true
  },
  desc: {
    keoZOQ: "xr9ek0c",
    kGuDYH: "x2ouz8m",
    kMwMTN: "xdxw5r1",
    ks0D6T: "x1kozois",
    kLWn49: "x1evy7pa",
    $$css: true
  },
  descWide: {
    kCS8Yb: "x1l7klhg",
    ks0D6T: "x1x1rfll",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  actions: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kOIVth: "x1mnnc3i",
    kwnvtZ: "x1a02dak",
    ks0D6T: "x193iq5w",
    k7Eaqz: "xeuugli",
    kjj79g: "x13a6bvl",
    koQZXg: "x8x9d4c",
    $$css: true
  }
};